import { Component } from '@angular/core';

@Component({
    selector: 'tree',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class TreeComponent {}
